/**
 * @param {Array} items
 * @param {Array} catalogItems
 * @return {Array}
 */

function getVariantsData(curr) {
  const updatedData = {
    ...curr,
    id: curr.item_id,
    price: curr.actual_amount,
    actual_price: curr.actual_amount,
    discounted_price: curr.discounted_price,
    amount: curr.discounted_price * curr.quantity,
    name: curr.item_name,
    variants_count: 1,
    variants_selected: [
      {
        variant_id: curr.variant_id,
        variant_name: curr.variant_name,
        quantity: curr.quantity,
        personalization_info: curr?.personalization_info || null,
      },
    ],
  };
  // Delete the key if it exists and then set it to null
  if (updatedData.hasOwnProperty('personalization_info')) {
    delete updatedData.personalization_info;
  }
  updatedData.personalization_info = null;
  return updatedData;
}
export const orderItemsToBuyAgain = (items) => {
  try {
    items = JSON.parse(JSON.stringify(items));

    if (!items || (items && items.length === 0)) return [];

    const map = new Map();
    const tempItems = items.reduce((acc, curr) => {
      /** Check if Item id not exist or item type is not of catalog or list */
      if (!curr.item_id || !(curr.item_type === 'catalog' || curr.item_type === 'list'))
        return acc;

      /** Check if item has variants */
      if (curr.variant_name) {
        /** check if this variants item_id already exist */
        if (map.has(curr.item_id)) {
          acc[map.get(curr.item_id)].variants_count += 1;
          acc[map.get(curr.item_id)].quantity =
            acc[map.get(curr.item_id)].quantity + curr.quantity;
          acc[map.get(curr.item_id)].variants_selected.push({
            variant_id: curr.variant_id,
            variant_name: curr.variant_name,
            quantity: curr.quantity,
            personalization_info: curr.personalization_info || null,
          });
        } else {
          /** variants item_id not exist */
          map.set(curr.item_id, acc.length);
          acc.push(getVariantsData(curr));
        }
      } else {
        /** Item has no variants */
        acc.push({
          ...curr,
          id: curr.item_id,
          price: curr.actual_amount,
          actual_price: curr.actual_amount,
          discounted_price: curr.discounted_price,
          amount: curr.discounted_price * curr.quantity,
          name: curr.item_name,
          variants_selected: [],
        });
      }

      return acc;
    }, []);

    return tempItems;
  } catch (err) {
    return [];
  }
};
